import React from "react";

export default function SpDashboard() {
  return (
    <div className="px-6">
      <div className="row my-5 spLeadDashboard">
        <div className="col-md-6">
          <h2>
            Lead Management <br /> Dashboard
          </h2>
          <div className="mt-5 pb-md-3">
            <h3>Comprehensive Pipeline Overview</h3>
            <p>
              Get a complete, real time view of your sales funnel at a single
              glance.
            </p>
          </div>
          <div className="pb-md-3">
            <h3>Lead Status Tracking</h3>
            <p>
              Monitor important data about your leads, such as the number of
              recently visited new leads, interested leads, leads converted to
              customers, and cold leads.
            </p>
          </div>
          <div className="pb-md-3">
            <h3>Powerful Analytics</h3>
            <p>
              The dashboard features customizable numbers and graphs for total
              leads and revenue analytics, which can be easily created and
              exported for reporting.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <img
            src="/images/spLeadDashboard.png"
            className="img-fluid"
            height={"400px"}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
